// extracted by mini-css-extract-plugin
export default {"mainCard":"InsuranceInfo_mainCard__FLho1","icon":"InsuranceInfo_icon__-Xv7g","controllerIcon":"InsuranceInfo_controllerIcon__6F6ca"};